import { render, staticRenderFns } from "./semifisheds-modal.vue?vue&type=template&id=fefaa584&"
import script from "./semifisheds-modal.vue?vue&type=script&lang=js&"
export * from "./semifisheds-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports